import type { FormControlSetting } from '@/app/editor/iframe/atom/Atom.model';

import { GpThirdParty } from '@/app/editor/iframe/atom/third-party/GpThirdParty';
const FormControlSettings: Array<FormControlSetting> = [
  {
    type: 'custom:align',
    name: 'alignment',
    targetSelector: '.module',
    property: '',
  },
  {
    type: 'html:attr',
    name: 'widget',
    targetSelector: '.module',
    property: 'data-widget',
    refreshType: 'all',
    options: [
      {
        key: 'product-section',
        value: 'Review Widget',
      },
      {
        key: 'home-section',
        value: 'Homepage Reviews',
      },
      {
        key: 'happy-page',
        value: 'Happy Customer Reviews',
      },
      {
        key: 'product-rating-anchorlink',
        value: 'Star Ratings',
      },
      {
        key: 'product-rating',
        value: 'Star Ratings',
      },
      {
        key: 'list-rating',
        value: 'Star Ratings in the List',
      },
    ],
    default_value: 'product-rating',
  },
  {
    type: 'custom:align',
    name: 'alignment',
    targetSelector: '.module',
    property: '',
  },
  {
    type: 'html:extraClass',
    name: 'extra_class',
    targetSelector: '.module',
    property: 'data-exc',
    default_value: '',
  },
];
/**
 * Hero Banner Atom Module
 */
export class GpLaiReviews extends GpThirdParty {
  public $el: JQuery;

  /**
   * override getLabel từ Atom
   * @returns Name
   */
  getLabel(): string {
    return this.$el.attr('data-label') || 'LAI AliExpress Reviews';
  }
  /**
   * override getLabel từ Atom
   * @returns Slug
   */
  getSlug(): string {
    return this.$el.attr('data-slug') || 'lai-aliexpress-reviews';
  }
  /**
   * getFormControlSettings;
   * @returns setting read/write from left-sidebar to live page
   */
  getFormControlSettings(): Array<FormControlSetting> {
    return FormControlSettings;
  }
  /**
   * check
   * @returns true: change setting after drag
   */
  isAutoRenderSetting() {
    return true;
  }
}
